import Navbar from '../components/Navbar';
import '../components/somos.css';
import imgEquipo from '../assets/images/equipo.png';
import useInView from '../hooks/useInView';

export default function Somos() {

  const [ref1, v1] = useInView();
  const [ref2, v2] = useInView();
  const [ref3, v3] = useInView();

  return (
    <>
      <Navbar />

      <section className="somos">

        {/* HERO */}
        <div className="somos-hero">
          <div className="overlay" />

          <div className="hero-content">
            <h1>¿Quiénes somos?</h1>
            <p>Soluciones industriales que impulsan el crecimiento</p>
          </div>
        </div>

        {/* HISTORIA PRO */}
        <div ref={ref1} className={`somos-content pro ${v1 ? 'show' : ''}`}>

        {/* TEXTO */}
        <div className="texto-pro">


          <h2>
            Soluciones que impulsan <br />
            el crecimiento industrial
          </h2>

          <p>
            COPAC es una empresa especializada en la producción y comercialización
            de papel kraft y soluciones de empaque.
          </p>

          <p>
            Acompañamos a nuestros clientes con calidad, eficiencia y compromiso
            en cada etapa del proceso.
          </p>

        </div>

        {/* IMAGEN */}
        <div className="imagen-pro">

          <img src={imgEquipo} alt="Equipo COPAC" />

        </div>

      </div>

        {/* CONTADORES */}
        <div ref={ref2} className={`contadores ${v2 ? 'show' : ''}`}>
          <div>
            <h3>+10</h3>
            <p>Año de experiencia</p>
          </div>

          <div>
            <h3>+100</h3>
            <p>Clientes atendidos</p>
          </div>

          <div>
            <h3>100%</h3>
            <p>Compromiso</p>
          </div>
        </div>

        {/* PILARES */}
        <div ref={ref3} className={`pilares ${v3 ? 'show' : ''}`}>
          <div className="card">
            <h3>Calidad</h3>
            <p>Procesos confiables y eficientes.</p>
          </div>

          <div className="card">
            <h3>Sostenibilidad</h3>
            <p>Responsabilidad ambiental.</p>
          </div>

          <div className="card">
            <h3>Innovación</h3>
            <p>Soluciones modernas para la industria.</p>
          </div>
        </div>

        {/* FRASE */}
        <div className="frase">
          <h2>"Construimos confianza a través de soluciones"</h2>
        </div>

      </section>
    </>
  );
}